import { EXTERNAL_LINKS } from "routes/paths";
import downloadMobileAppImage from "assets/images/download-app/download-mobile-app.png";
import appStoreImage from "assets/images/app-store-desktop.svg";
import playStoreImage from "assets/images/play-store-desktop.svg";
import "./index.scss";

export const DownloadMobileApp = () => {
  return (
    <section
      className="download-mobile-app-container"
      data-testid="download-mobile-app"
    >
      <div className="mobile-app-image-wrapper">
        <img
          className="mobile-app-image"
          src={downloadMobileAppImage}
          alt="Download the app"
        />
      </div>
      <div className="mobile-app-text-wrapper">
        <h4 className="mobile-app-subtitle">AVAILABLE ON DESKTOP + MOBILE</h4>
        <h2 className="mobile-app-title">Pay and save on the go with GCX.</h2>
        <p className="mobile-app-description">
          Download the GCX app to shop, store and redeem your cards anytime,
          anywhere.
        </p>
        <div className="mobile-app-buttons">
          <a
            className="mobile-app-button-wrapper"
            href={EXTERNAL_LINKS.DOWNLOAD_APP_STORE}
          >
            <img src={appStoreImage} alt="Download on the App Store" />
          </a>

          <a
            className="mobile-app-button-wrapper"
            href={EXTERNAL_LINKS.DOWNLOAD_PLAY_STORE}
          >
            <img src={playStoreImage} alt="Get it on Google Play" />
          </a>
        </div>
      </div>
    </section>
  );
};
